/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStopwatch} from '@fortawesome/pro-duotone-svg-icons';

const TimesheetsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faStopwatch} {...props} />
);

export default TimesheetsIcon;
